import { useState } from "react";
import { OverlayHostContext } from "@/design/primitives";
import { FrameCaption } from "./FrameCaption";

export const PhoneFrame = ({ children, caption = "Mobile · 390 × 844", testId = "review-frame-mobile" }) => {
  const [host, setHost] = useState(null);
  return (
    <figure data-testid={testId} className="shrink-0">
      <FrameCaption>{caption}</FrameCaption>
      <div className="os-card rounded-[52px] border border-os-border-strong p-[10px]">
        <div className="os-canvas relative h-[844px] w-[390px] overflow-hidden rounded-[42px] border border-os-border">
          <div aria-hidden className="absolute left-1/2 top-3 z-40 h-[26px] w-[96px] -translate-x-1/2 rounded-full bg-os-border" />
          <OverlayHostContext.Provider value={host}>
            <div data-testid={`${testId}-scroll`} className="h-full overflow-y-auto overflow-x-hidden pt-12">
              {children}
            </div>
          </OverlayHostContext.Provider>
          <div ref={setHost} className="pointer-events-none absolute inset-0 z-50" />
        </div>
      </div>
    </figure>
  );
};
